<template>
  <div class="wrap" :class="namespaceGroup">
    <div class="title" v-if="type !== 'benefitMoreimage'">{{ item.name }}</div>
    <div class="desc" v-if="type !== 'benefitMoreimage'">{{ item.desc }}</div>
    <div class="content">
      <van-image
        v-for="item of benefitList"
        :key="item.id"
        :src="item.display_img_url"
        @click="handleDraw(item)"
        :data-type="item.benefit_type"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";

import { useRouter, useStore } from "@/components/use/base";

export default defineComponent({
  name: "benefitMore",
  props: ["item", "card", "type", "namespace"],

  setup(props) {
    const router = useRouter();
    const store = useStore();

    const namespaceGroup = computed(
      () => store.state.namespaceInfo.namespace_group_en
    );
    const benefitList = computed(() => {
      const list = props.card.benefit_list.map((item) => item.type);
      return (
        props.item.productInfo.filter((item) =>
          list.includes(item.benefit_type)
        ) || []
      );
    });

    const handleDraw = (item) => {
      router.push(`benefitDetail?benefit_type=${item.benefit_type}`);
    };

    return {
      benefitList,
      namespaceGroup,
      handleDraw,
    };
  },
});
</script>


<style lang="less" scoped>
.weixinjinke {
  margin-top: 0px !important;
  .title {
    margin-top: 32px;
  }

  .content {
    display: block !important;
    gap: 0px;

    /deep/ .van-image {
      display: block;
      height: 122px;
      margin-top: 12px !important;
    }
  }
}

.wrap {
  padding: 0 12px;
  margin-top: 32px;

  .title {
    font-weight: 600;
    font-size: 18px;
    color: #222222;
    line-height: 22px;
  }

  .desc {
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 16px;
    margin-top: 7px;
  }
}

.content {
  margin-top: 16px;
  display: flex;
  flex-wrap: nowrap;
  gap: 6px;
}
</style>